import { render } from "./component-kpp.vue?vue&type=template&id=41c1d807"
import script from "./component-kpp.vue?vue&type=script&setup=true&lang=js"
export * from "./component-kpp.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-version-card/components/component-kpp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "41c1d807"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('41c1d807', __exports__)) {
    api.reload('41c1d807', __exports__)
  }
  
  module.hot.accept("./component-kpp.vue?vue&type=template&id=41c1d807", () => {
    api.rerender('41c1d807', render)
  })

}


export default __exports__